import React from 'react';
import { InfoWindow } from '@vis.gl/react-google-maps';
import './addressmap.css'
import { getAddress, getOtherCompanyInfo } from './utils';
import CopyToClipboard from '../utilComponents/CopyToClipboard';


const CompanyInfoWindow = ({ anchor, company, onCloseClick, roadDistance, roadDuration }) => {

    const companyInfo = getOtherCompanyInfo(company);



    return (
        <InfoWindow
            anchor={anchor}
            pixelOffset={[0, -2]}
            onCloseClick={onCloseClick}
            headerContent={<CopyToClipboard className='info-window-header'>{getAddress(company)}</CopyToClipboard>}
        >
            <div className='info-window-body' style={{ border: "none", boxShadow: "none" }}>
                <div className="company-info">
                    <div>
                        {/* <p>{getAddress(company)}</p> */}
                        {company.miles !== null && (
                            <CopyToClipboard
                                class="distance-time"
                                text={`${company.miles} miles`}
                            >
                                Distance: <strong>{company.miles} miles</strong>
                            </CopyToClipboard>
                        )}
                        {/* <CopyToClipboard
                            className="distance-time"
                            text={`${roadDistance}`}
                        >
                            Road Miles: <strong>{roadDistance}</strong>
                        </CopyToClipboard> */}
                        <CopyToClipboard
                            className="distance-time"
                            text={`${roadDuration}`}
                        >
                            Time by Car: <strong>{roadDuration}</strong>
                        </CopyToClipboard>
                    </div>
                </div>

                {
                    companyInfo && companyInfo.length > 0 && (
                        <>
                            <hr />
                            <div className="company-info-items-container">

                                {companyInfo.map((info, index) => (
                                    <>
                                        <CopyToClipboard
                                            className="distance-time"
                                            text={info.content}
                                        >
                                            <strong>{info.attribute}</strong>: {info.content}
                                        </CopyToClipboard> <br />
                                    </>
                                ))}

                            </div>
                        </>
                    )
                }
            </div>
        </InfoWindow >
    );
};

export default CompanyInfoWindow;